/**
 * Registers a callback to be called when the application is sent to the background
 * @param callback The callback to register
 * @returns A function to call to unregister the callback
 */
export function onAppPause(callback: () => void): () => void {
  document.addEventListener('pause', callback);

  return () => {
    document.removeEventListener('pause', callback);
  };
}
